<template>
  <div class="popup-form-warp" v-if="popupFormShow">
    <div class="popup-form" v-if="popupFormShow && !submitSuccess">
      <div class="close_button">
        <img src="~_img/popupform/close.png" class="close-img" @click="closeFrom()" />
        <div></div>
      </div>
      <div class="form-content">
        <p>免费领取</p>
        <p>1对1学习规划指导方案</p>
        <div class="form">
          <div class="tel-wrapper" v-if="isNeedPhone">
            <input type="text" name placeholder="请输入手机号" v-model.trim="formDate.telphone" @blur="focusLeave()"/>
            <span class="errortoast" v-if="phoneToast">{{phoneToastMsg}}</span>
          </div>
          <div class="code-wrapper">
            <input
              class="code-input"
              type="text"
              name
              placeholder="请输入验证码"
              v-model.trim="formDate.code"
              @click="clickPopupcode"
            />
          <span class="errortoast" v-if="codeToast">{{codeToastMsg}}</span>
            <span class="send-code" @click="sendCode()" data-action-name="mas_popup_code">{{sendcodeBtn}}</span>
          </div>
          <div class="name-wrapper">
            <input
              class="name-input"
              type="text"
              name
              placeholder="请输入您的姓名"
              v-model.trim="formDate.name"
              data-action-name="mas_popup_name"
              @blur="clickPopupName"
            />
            <span class="errortoast" v-if="nameToast">请输入您的姓名</span>
            <div class="grade-select" @click="choiceGradeShow()" data-action-name="mas_popup_grade" data-action-args="">
              {{gradeName}}
            </div>
            <ul class="grade-list" v-if="gradeListShow">
              <li
                v-for="(value,key) in gradeList"
                :key="key"
                :value="value.value"
                @click="choiceGrade(value.value,value.label)"
              >{{value.label}}</li>
            </ul>
          <span class="errortoast gradetoast" v-if="gradeToast">请选择年级</span>
          </div>
          <div class="button" @click="submitForm()" data-action-name="mas_popup_commit">点击领取</div>
        </div>
      </div>
    </div>
    <div class="submit-success" v-if="submitSuccess">
      <div class="close_button">
        <img src="~_img/popupform/close.png" class="close-img" @click="closeFrom()" />
        <div></div>
      </div>
      <img src="//img4.xes1v1.com/pclp/online/successbgtop.png"  class="success" alt="">
    </div>
  </div>
</template>

<script>
import { sendCodePost, addfeedback } from "@/request/index.js";
import {gradeList} from '@/const/list.js';
import guardian , { LogType }from '@xes/dh-guardian-sdk'
import {saTrack} from '@xes/dh-sensor';

export default {
  name: "popupform",
  props: {
    isNeedPhone: {
      type: Boolean,
      default: true
    },
    isPopupFormShow: {
      type: Boolean,
      default: false
    },
    isDirectSend: {
      type: Boolean,
      default: false
    },
    bannerPhone: {
      type: String,
      default: ""
    },
    subjectName: {
      type: String,
      default: ""
    },
    success: {
      type: Boolean,
      default: false
    },
    origin: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      gradeList,
      gradeName: "请选择年级",
      gradeListShow: false,
      toastMsg: "",
      popupFormShow: false,
      submitSuccess: false,
      sendcodeBtn: "发送验证码",
      sendingCode: false,
      submitFlag: true,
      sendcodeNum: 0,
      formDate: {
        telphone: "",
        grade: "0",
        code: "",
        name: "",
        subject: this.subjectName
      },
      timer: "",
      phoneToast: false,
      codeToast: false,
      nameToast: false,
      gradeToast: false,
      toastShow: false,
      toastShowTimer: "",
      phoneToastMsg: "",
      codeToastMsg: "",
    };
  },
  mounted() {
  },
  watch: {
    isPopupFormShow() {
      this.popupFormShow = this.isPopupFormShow;
    },
    toastShow() {
      if(this.toastShow) {
        this.toastShowTimer = setTimeout(() => {
          this.toastShow = false;
          this.phoneToast = false;
          this.codeToast = false;
          this.nameToast = false;
          this.gradeToast = false;
          this.submitFlag = true;
        }, 1000);
      }
    },
    isDirectSend() {
      if (this.isDirectSend) {
        this.formDate.telphone = this.bannerPhone;
        this.sendCode();
      }
    },
    subjectName() {
      this.formDate.subject = this.subjectName;
    },
    success() {
      this.submitSuccess = this.success;
    }
  },
  methods: {
    clickPopupcode() {
      let data = {
        str_param1: '弹窗',
        str_param3: '输入验证码'
      };
      saTrack("clickSelectOption",data);
    },
    clickPopupName() {
      let data = {
        str_param1: '弹窗',
        str_param4: this.formDate.name
      };
      saTrack("clickSelectOption",data);
    },
    choiceGradeShow() {
      this.gradeListShow = !this.gradeListShow;
      if(this.gradeListShow) {
        document.addEventListener('click',(e)=>{
          if(e.target.className != 'grade-select'){
              this.gradeListShow = false;
          }
        })
      }
    },
    choiceGrade(value,label) {
      let data = {
        str_param1: '弹窗',
        str_param5: label
      };
      saTrack("clickSelectOption",data);
      this.formDate.grade = value;
      this.gradeName = label;
      this.gradeListShow = false;
    },
    resetForm() {
      this.formDate = {
        telphone: "",
        grade: "0",
        code: "",
        name: "",
        subject: this.subjectName
      };
      this.sendcodeBtn = "获取验证码";
      this.sendingCode = false;
      clearInterval(this.timer);
    },
    sendCode() {
      if (!this.formDate.telphone) {
        this.toastShow = true;
        this.phoneToastMsg = "请输入手机号"
         this.phoneToast = true;
        return;
      } else if (!(/^1[345789]\d{9}$/.test(this.formDate.telphone))) {
        this.toastShow = true;
        this.phoneToast = true;
        this.phoneToastMsg = "请输入正确手机号"
        return;
      }
      if (!this.sendingCode) {
        this.sendingCode = true;
        this.sendcodeNum = 60;
        this.sendcodeBtn = "已发送(60)";
        this.timer = setInterval(() => {
          this.sendcodeNum--;
          this.sendcodeBtn = "已发送("+this.sendcodeNum+")";
          if (this.sendcodeNum === 0) {
            clearInterval(this.timer);
            this.sendingCode = false;
            this.sendcodeBtn = "重新获取";
          }
        }, 1000);
        sendCodePost({
          mobile: this.formDate.telphone
        }).then(res => {
          if (res.data.error_code === 0) {
            this.toastShow = true;
            this.codeToast = true;
            this.codeToastMsg = res.data.message
          } else {
            this.toastShow = true;
            this.codeToast = true;
            this.codeToastMsg = res.data.message
            clearInterval(this.timer);
            this.sendingCode = false;
            this.sendcodeBtn = "重新获取";
            // this.sendCodeBtnOpacity = 1;
          }
        }).catch(err => err);
      }
    },
    httpResultOperation(res) {
      this.submitFlag = true;
      if (res.data.status === 0) {
        this.toastShow = true;
        this.codeToast = true;
        this.codeToastMsg = res.data.message
        let data = {
          clue_id: -1,
          int_param1: 0,
          str_param4: '弹窗',
          str_param5: this.origin
        }
        saTrack("clickSubmitInfo",data);
      } else if (res.data.status === 1) {
        let saData = {
          clue_id: res.data.result.cid,
          int_param1: 1,
          str_param4: '弹窗',
          str_param5: this.origin
        }
        saTrack("clickSubmitInfo",saData);
        this.submitSuccess = true;
        this.resetForm();
      }
    },
    submitForm() {
      let data = null;
      if (!this.formDate.telphone) {
        this.toastShow = true;
        this.phoneToast = true;
        this.phoneToastMsg = "请输入手机号";
        this.submitFlag = false;
      }else if (!(/^[1][34578][0-9]{9}$/.test(this.formDate.telphone))) {
        this.toastShow = true;
        this.phoneToast = true;
        this.phoneToastMsg = "请输入正确手机号";
        this.submitFlag = false;
      }
      if (!this.formDate.code) {
        this.toastShow = true;
        this.codeToast = true;
        this.codeToastMsg = "请输入验证码";
        this.submitFlag = false;
      }else if (isNaN(parseInt(this.formDate.code))) {
        this.toastShow = true;
        this.codeToast = true;
        this.codeToastMsg = "请输入正确验证码";
        this.submitFlag = false;
      }
      if (this.formDate.name === '') {
        this.toastShow = true;
        this.nameToast = true;
        this.submitFlag = false;
      }
      if (this.formDate.grade === '0') {
        this.toastShow = true;
        this.gradeToast = true;
        this.submitFlag = false;
        return
      }
      if (this.submitFlag) {
        this.submitFlag = false;
        data = {
          username:this.formDate.name,
          class_id:parseInt(this.formDate.grade),
          mobile:parseInt(this.formDate.telphone),
          code:parseInt(this.formDate.code),
          source_url: window.location.href,
          event: this.$getUrlParam('event') || '10057',
          source: this.$getUrlParam('channel') || '277',
          subject: this.formDate.subject,
        };

        addfeedback(data).then(res => {
          this.submitFlag = true;
          this.httpResultOperation(res);
        }).catch(() => {
          let saData = {
            clue_id: -1,
            int_param1: 0,
            str_param4: '弹窗',
            str_param5: this.origin
          }
          saTrack("clickSubmitInfo",saData);
        });
      }
    },
    closeFrom() {
      this.resetForm();
      this.popupFormShow = false;
      this.submitSuccess = false;
      this.gradeListShow = false;
      this.gradeName = "请选择年级"
      this.$emit("popupFormClose", false);
    },
    focusLeave() {
      let data = {
        str_param1: '弹窗',
        str_param2: this.formDate.telphone
      };
      saTrack("clickSelectOption",data);
      guardian.log('click',{action_name: "mas_popup_phone_number"}, LogType.interaction)
    }
  }
};
</script>
<style scoped lang="scss">
.popup-form-warp {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  .popup-form, .submit-success {
    width: 748px;
    height: 540px;
    min-height: 432px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 1001;
    background: url("//img4.xes1v1.com/pclp/online/acquirebg.png?t=20210508") center no-repeat;
    background-size: 100% 100%;
    .close_button {
        width: 25px;
        height: 40px;
      .close-img {
        width: 25px;
        height: 25px;
        display: block;
      }
      div {
        width: 12px;
        height: 15px;
        border-right: 1px solid #FFFFFF;
      }
      position: absolute;
      right: 23px;
      top: -40px;
    }
    .form-content {
      width: 748px;
      height: 540px;
      padding: 89px 64px 150px 438px;
      box-sizing: border-box;
    }
    .errortoast {
      font-size: 12px;
      color: rgba(224,39,39,1);
      line-height: 14px;
      margin-left: 9px; 
      position: absolute;
      top:62px;
      left: 0;
      z-index: 1;
    }
    .gradetoast{
      left:126px;
    }
    p {
      font-size: 25px;
      color: rgba(224, 39, 39, 1);
      line-height: 22px;
      text-align: center;
    }
    p:nth-child(2) {
      font-size: 20px;
      color: #333;
      margin: 10px 0 6px;
    }
    input {
      box-sizing: border-box;
      width: 128px;
      height: 55px;
      outline: 0;
      border: none;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 1px;
      padding: 19px 0 0 10px;
    }
    .tel-wrapper,
    .code-wrapper,
    .name-wrapper {
      position: relative;
      width: 240px;
      height: 56px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      margin: 0 auto;
    }
    .form {
      height: 242px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .tel-wrapper {
      border-bottom: 1px solid rgba(204, 204, 204, 1);
      input {
        width: 100%;
      }
    }
    .code-wrapper,
    .name-wrapper {
      border-bottom: 1px solid rgba(204, 204, 204, 1);

      .send-code {
        float: right;
        width: 104px;
        height: 30px;
        border-radius: 2px;
        box-sizing: border-box;
        border: 1px solid rgba(224, 39, 39, 1);
        font-size: 15px;
        color: rgba(224, 39, 39, 1);
        line-height: 30px;
        letter-spacing: 1px;
        text-align: center;
        margin-top: 18px;
      }
      .send-code:hover {
        cursor: pointer;
      }
    }
    .grade-select {
      position: relative;
      margin-top: 18px;
      float: right;
      box-sizing: border-box;
      width: 104px;
      height: 30px;
      border-radius: 2px;
      border: 1px solid rgba(224, 39, 39, 1);
      font-size: 15px;
      color: rgba(224, 39, 39, 1);
      line-height: 30px;
      letter-spacing: 1px;
      padding-left: 8px;
    }
    .grade-select::before {
      position: absolute;
      top: 10px;
      right: 5px;
      content: '';
      border: 3px solid transparent;
      border-bottom: 5px solid rgba(224, 39, 39, 1);
      border-top: none;
    }
    .grade-select::after{
      position: absolute;
      top: 17px;
      right: 5px;
      content: '';
      border: 3px solid transparent;
      border-top: 5px solid rgba(224, 39, 39, 1);
      border-bottom: none;
    }
    .grade-list {
        width: 104px;
        box-sizing: border-box;
        position: relative;
        left: 136px;
        top: -8px;
        font-size: 15px;
        border-radius: 2px;
        border: 1px  rgb(30, 144, 255) solid;
        background: #FFF;
        li{
          letter-spacing: 1px;
          height: 20px;
          line-height: 20px;
          padding-left: 8px; 
        }
      }
      .grade-list li:hover {
        color: #FFF;
        background:  rgb(30, 144, 255);
      }
    .button {
      width: 246px;
      height: 40px;
      margin: 26px auto 0;
      background: linear-gradient(
        90deg,
        rgba(250, 98, 85, 1) 0%,
        rgba(219, 48, 42, 1) 100%
      );
      border-radius: 20px;
      font-size: 16px;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      letter-spacing: 1px;
      text-align: center;
    }
    .button:hover {
        cursor: pointer;
    }
  }
  .submit-success {
    background: url("//img4.xes1v1.com/pclp/online/successbgdown.png") center no-repeat;
    .success {
      margin: 81px 117px 264px 491px;
    }
  }
}
</style>
